import { Typography, useMediaQuery } from '@mui/material';
import { Datagrid, FunctionField, List, SimpleList, TextField, useResourceContext } from 'react-admin';
import moment from 'moment';

const ListAiSearch = () => {
	const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
	const context = useResourceContext({ resource: 'member/get-searches' });
	return (
		<List resource="member/get-searches">
			{isSmall ? (
				<SimpleList
					resource={context}
					primaryText={(record) => (
						<Typography textAlign="right" fontWeight={'600'}>
							{record.prompt || record.id}
						</Typography>
					)}
					secondaryText={(record) => (
						<Typography textAlign="right">
							{record.member?.email || ''}
						</Typography>
					)}
				/>
			) : (
				<Datagrid dir="rtl" resource="member/get-searches">
					<TextField source="member.email" textAlign="right" label="חבר" />
					<TextField source="prompt" textAlign="right" label="פרומפט" />
					<TextField source="rating" textAlign="center" label="דירוג" />
					<TextField source="reason" textAlign="right" label="סיבה" />
					<FunctionField
						label="מומחים"
						textAlign="right"
						render={(record: any) => {
							if (!record.expert_ids || record.expert_ids.length === 0) return '';
							return record.expert_ids.map((expert: any) => expert.name).join(', ');
						}}
					/>
					<FunctionField
						label="תאריך יצירה"
						textAlign="center"
						render={(record: any) =>
							record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : ''
						}
					/>
				</Datagrid>
			)}
		</List>
	);
};

export default ListAiSearch;

